export default "__VITE_ASSET__23ee51b3__"